import React, { useState, useCallback } from 'react';
import {
  LwBaseModal,
  useDualUserData,
  useSingleUserData,
} from './topModalCommon';
import {
  RenderEditTalkroomNameDisplay,
  RenderShowTalkroomNameDisplay,
} from './nameDisplay';
import { RenderSearchCondition } from './searchCondition';
import {
  RenderTalkroomRegisterUserDisplay,
  RenderTalkroomShowUserDisplay,
} from './usersDisplay';
import {
  RenderTalkroomRegisterFooter,
  RenderTalkroomShowFooter,
} from './footer';
import { useErrorInfomation } from './errorInfomation';
import {
  AppendableUsers,
  AssignUsers,
  ShowUsers,
  TalkroomName,
} from '../../services/lwUser/Talkroom';
import { swapLwUsersBetweenLwUserList } from '../../services/lwUser/Base';
import { SearchCondition } from '../../services/lwUser/SearchCondition';

/**
 * トークルーム登録時のモーダル
 * @param {number} fieldId 現場ID
 * @param {string} fieldName 現場名
 * @param {number} lwGroupId グループID
 * @param {function} clickBack 戻るボタンを押下した時に動作する関数
 * @param {function} clickSubmit 送信ボタンを押下した時に動作する関数
 **/
function LwTalkroomRegisterModal({
  fieldId,
  fieldName,
  lwGroupId,
  clickBack,
  clickSubmit,
}) {
  const [talkroomName, setTalkroomName] = useState(new TalkroomName(fieldName));
  const [searchCondition, setSearchCondition] = useState(new SearchCondition());
  const [tempSearchCondition, setTempSearchCondition] = useState(new SearchCondition());
  const [isLoading, setIsLoading] = useState(false);
  const { displayErrorInfomation, RenderErrorInfomation } = useErrorInfomation(
    clickBack
  );
  const getAppendableUsers = useCallback(
    async () => {
      return await AppendableUsers.createByApiData(
        fieldId,
        lwGroupId,
        searchCondition
      ).finally(() => {
        setIsLoading(false);
      });
    },
    [fieldId, lwGroupId, searchCondition]
  );
  const getAssignUsers = useCallback(() => {
    return new AssignUsers([]);
  }, []);
  const { searchedleftUsers, searchedrightUsers } = useDualUserData(
    getAppendableUsers,
    getAssignUsers,
    displayErrorInfomation
  );
  const [leftMovedUserIds, setLeftMovedUserIds] = useState([]);
  const [rightMovedUserIds, setRightMovedUserIds] = useState([]);

  const {
    new_first_lw_users: appendableUsers,
    new_second_lw_users: assignUsers,
  } = swapLwUsersBetweenLwUserList(
    searchedleftUsers,
    searchedrightUsers,
    rightMovedUserIds,
    leftMovedUserIds
  );
  return (
    <LwBaseModal
      topClassName={'dialog--full LwEditModal'}
      title={'トークルームの編集'}
      renderBody={
        <React.Fragment>
          <RenderEditTalkroomNameDisplay
            fieldName={fieldName}
            talkroomName={talkroomName}
            setTalkroomName={setTalkroomName}
          />
          <RenderSearchCondition
            fieldId={fieldId}
            setSearchCondition={setSearchCondition}
            tempSearchCondition={tempSearchCondition}
            setTempSearchCondition={setTempSearchCondition}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          <RenderTalkroomRegisterUserDisplay
            appendableUsers={appendableUsers}
            assignUsers={assignUsers}
            setLeftMovedUserIds={setLeftMovedUserIds}
            setRightMovedUserIds={setRightMovedUserIds}
          />
        </React.Fragment>
      }
      renderFooter={
        <React.Fragment>
          <RenderTalkroomRegisterFooter
            fieldId={fieldId}
            talkroomName={talkroomName}
            registerlwUserIds={rightMovedUserIds}
            clickBack={clickBack}
            clickSubmit={clickSubmit}
            displayErrorInfomation={displayErrorInfomation}
          />
        </React.Fragment>
      }
      renderErrorInfomation={<RenderErrorInfomation />}
    />
  );
}

/**
 * トークルーム閲覧時のモーダル
 * @param {number} fieldId 現場ID
 * @param {string} fieldName 現場名
 * @param {number} lwTalkroomId トークルームID
 * @param {number} lwTalkroomName トークルーム名
 * @param {function} clickBack 戻るボタンを押下した時に動作する関数
 **/
function LwTalkroomShowModal({
  fieldId,
  fieldName,
  lwTalkroomId,
  lwTalkroomName,
  clickBack,
}) {
  const [searchCondition, setSearchCondition] = useState(new SearchCondition());
  const [tempSearchCondition, setTempSearchCondition] = useState(new SearchCondition());
  const [isLoading, setIsLoading] = useState(false);
  const { displayErrorInfomation, RenderErrorInfomation } = useErrorInfomation(
    clickBack
  );
  const getShowUsers = useCallback(
    () => {
      return ShowUsers.createByApiData(
        fieldId,
        lwTalkroomId,
        searchCondition
      ).finally(() => {
        setIsLoading(false);
      });
    },
    [fieldId, lwTalkroomId, searchCondition]
  );
  const { searchedUsers: showUsers } = useSingleUserData(
    getShowUsers,
    displayErrorInfomation
  );

  return (
    <LwBaseModal
      topClassName={'dialog--full LwShowModal'}
      title={'トークルームの閲覧'}
      renderBody={
        <React.Fragment>
          <RenderShowTalkroomNameDisplay
            talkroomName={lwTalkroomName}
            fieldName={fieldName}
          />
          <RenderSearchCondition
            fieldId={fieldId}
            setSearchCondition={setSearchCondition}
            tempSearchCondition={tempSearchCondition}
            setTempSearchCondition={setTempSearchCondition}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
          />
          <RenderTalkroomShowUserDisplay showUsers={showUsers} />
        </React.Fragment>
      }
      renderFooter={
        <React.Fragment>
          <RenderTalkroomShowFooter clickBack={clickBack} />
        </React.Fragment>
      }
      renderErrorInfomation={<RenderErrorInfomation />}
    />
  );
}

export { LwTalkroomRegisterModal, LwTalkroomShowModal };



// WEBPACK FOOTER //
// ./src/components/lwUser/topModalTalkroom.jsx